import React from "react";
import { Card, Typography, Row, Col } from "antd";
import "./PrivacyPolicy.module.css";

const { Title, Paragraph } = Typography;

const PrivacyPolicyPage: React.FC = () => {
  return (
    <div className="privacy-policy-page">
      <Row gutter={[16, 16]} justify="center">
        <Col xs={24} md={20} lg={16}>
          <Card>
            <Title level={1}>Privacy Policy</Title>

            <Paragraph>
              Ai sensi del Regolamento UE 2016/679 (GDPR) e del Codice in
              materia di protezione dei dati personali (D.Lgs. 196/2003), la
              presente informativa descrive le modalità di raccolta, utilizzo e
              protezione dei dati personali degli utenti del sito corerare.it,
              gestito da Università degli Studi di Salerno – Dipartimento di
              Medicina, Chirurgia e Odontoiatria – Scuola Medica Salernitana.
            </Paragraph>

            <Title level={2}>Titolare del trattamento</Title>
            <Paragraph>
              Università degli Studi di Salerno
              <br />
              Via S. Allende, 84081 Baronissi (SA)
              <br />
              P.IVA: 00851300657
              <br />
              Email: rarecardiounisa@gmail.com
            </Paragraph>

            <Title level={2}>Dati raccolti</Title>
            <Paragraph>
              • Dati forniti volontariamente dall'utente (es. iscrizione alla
              piattaforma)
              <br />• Dati di navigazione raccolti automaticamente (es. IP,
              browser, pagine visitate)
            </Paragraph>

            <Title level={2}>Finalità del trattamento</Title>
            <Paragraph>
              • Gestione del sito e della piattaforma
              <br />
              • Comunicazioni informative e servizi richiesti dagli utenti
              <br />• Adempimenti legali e contabili
            </Paragraph>

            <Title level={2}>Base giuridica</Title>
            <Paragraph>
              • Esecuzione di un contratto o richiesta dell'utente
              <br />
              • Obblighi legali
              <br />• Consenso espresso per finalità specifiche (es. newsletter)
            </Paragraph>

            <Title level={2}>Diritti dell'utente</Title>
            <Paragraph>
              L'utente può in qualsiasi momento:
              <br />
              • Accedere ai propri dati
              <br />
              • Chiederne la rettifica o cancellazione
              <br />
              • Opporsi al trattamento o richiederne la limitazione
              <br />
              • Richiedere la portabilità dei dati
              <br />
              <br />
              Per esercitare i diritti, contattare il titolare ai recapiti sopra
              indicati.
            </Paragraph>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default PrivacyPolicyPage;
